export const setValue = (node = {}, path, value) => {
  if (!path.length) {
    return value;
  }

  return {
    ...node,
    [path[0]]: setValue(node[path[0]], path.slice(1), value),
  };
};

export const multiSelectDefaultValues = (options, values) => {
  const defaultValues = [];
  (values || []).forEach(({ value }) => {
    const foundOption = options.find(option => option.value === value);
    if (foundOption) {
      defaultValues.push(foundOption);
    }
  });
  return defaultValues;
};

export const multiSelectChanged = (clientId, storeFormData, fieldName) => values => {
  storeFormData(setValue({}, fieldName.split('.'), values || []), clientId);
};

export const simpleSelectDefaultValue = (options, value) =>
  options.find(option => option.value == value) || {
    // eslint-disable-line
    label: '',
    value: '',
  };

export const simpleSelectDefaultValueOrNull = (options, value) =>
  options.find(option => option.value == value); // eslint-disable-line

export const simpleSelectChanged = (clientId, storeFormData, fieldName) => v => {
  const value = v ? v.value : null;
  storeFormData(setValue({}, fieldName.split('.'), value), clientId);
};

export const advInputTextChanged = (clientId, storeFormData, fieldName) => v => {
  storeFormData(setValue({}, fieldName.split('.'), v), clientId);
};

export const inputTextChanged = (clientId, storeFormData, fieldName) => event => {
  storeFormData(setValue({}, fieldName.split('.'), event.target.value), clientId);
};

export const inputCheckboxClicked = (clientId, storeFormData, fieldName) => event => {
  storeFormData(setValue({}, fieldName.split('.'), event.target.checked), clientId);
};

export const inputNumericRadioClicked = (clientId, storeFormData, fieldName) => event => {
  storeFormData(setValue({}, fieldName.split('.'), +event.target.value), clientId);
};

export const simpleSelectChangedToNonNull = (clientId, storeFormData, fieldName) => selection => {
  if (selection && Object.keys(selection).length > 0 && 'value' in selection) {
    const { value } = selection;
    storeFormData(setValue({}, fieldName.split('.'), value), clientId);
  }
};
